import "./Chatbot.css";
import logo from "../avatar.png";
import { Widget, addResponseMessage, toggleMsgLoader } from "react-chat-widget";
import "react-chat-widget/lib/styles.css";
import React from "react";
const { detect } = require("detect-browser");
const browser = detect();

class Chatbot extends React.Component {
  componentDidMount() {
    localStorage.clear();
  }
  addSenderName = (type) => {
    const targetNode = document.getElementById("messages");
    const config = { attributes: false, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
      switch (type) {
        case "user":
          for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
              var userTag = document.createElement("span");
              var content =
                localStorage.username !== undefined
                  ? `${localStorage.username}:`
                  : "Visitor:";
              var userText = document.createTextNode(content);
              userTag.className = "senderName";
              userTag.appendChild(userText);
              const messages = document.getElementsByClassName("rcw-client");
              if (messages.length !== 0) {
                messages[messages.length - 1].insertBefore(
                  userTag,
                  messages[messages.length - 1].childNodes[0]
                );
              }
              observer.disconnect();
            }
          }
          break;
        case "bot":
          for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
              var botTag = document.createElement("span");
              var botText = document.createTextNode("Line:");
              botTag.className = "senderName";
              botTag.appendChild(botText);
              const messages = document.getElementsByClassName("rcw-response");
              if (messages.length !== 0) {
                messages[messages.length - 1].insertBefore(
                  botTag,
                  messages[messages.length - 1].childNodes[0]
                );
              }
              observer.disconnect();
            }
          }
          break;
        default:
          break;
      }
      // Use traditional 'for loops' for IE 11
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
    return observer;
  };

  sendMessage = async (url, message, companyId) => {
    return new Promise(function(resolve, reject) {
      const data = {
        message,
        company_id: companyId,
        device: `${browser.name}|${browser.os}`,
        uuid: localStorage.uuid ? localStorage.uuid : null,
      };
      console.log(data)
      console.log(browser);
      const xhr = new XMLHttpRequest();
      xhr.timeout = 20000;
      xhr.onreadystatechange = function(e) {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 400) {
            var response = this.response ? JSON.parse(this.response) : {};
            if (response.uuid) {
              if (!localStorage.uuid || localStorage.uuid !== response.uuid) {
                localStorage.setItem("uuid", response.uuid);
              }
            }
            if (response.message && response.message.includes(">>>")) {
              localStorage.clear();
            }
            if (response.username) {
              localStorage.username =
                response.username.charAt(0).toUpperCase() +
                response.username.slice(1);
            }
            resolve(response);
          } else {
            reject(xhr.status);
          }
        }
      };
      xhr.ontimeout = function() {
        reject("timeout");
      };
      xhr.open("post", url, true);
      xhr.setRequestHeader("Content-type", "application/json");
      xhr.send(JSON.stringify(data));
    });
  };

  handleSendMessage = async (newMessage) => {
    var observer = this.addSenderName("user");
    toggleMsgLoader();
    var response = await this.sendMessage(this.props.apiURL, newMessage, this.props.companyId);
    this.addSenderName("bot");
    toggleMsgLoader();
    addResponseMessage(response.message);
    observer.disconnect();
  };

  render() {
    return (
        <Widget
        title={this.props.chatTitle}
        subtitle=""
        profileAvatar={logo}
        handleNewUserMessage={this.handleSendMessage}
      />
    );
  }
}

export default Chatbot;
